import { render, staticRenderFns } from "./ListUsers.vue?vue&type=template&id=134439c0&scoped=true&"
import script from "./ListUsers.vue?vue&type=script&lang=ts&"
export * from "./ListUsers.vue?vue&type=script&lang=ts&"
import style0 from "./ListUsers.vue?vue&type=style&index=0&id=134439c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134439c0",
  null
  
)

export default component.exports